import { isArticlePage, isNewsYouCanUsePage, isVideoArticlePage } from '../../utils/aem-utils';
import { isMobile } from '../../utils/device-utils';

export const advTopBottomModule = {
  name: 'Adv Top Bottom',
};

export const advArticleModule = {
  name: 'Adv Article',
  shouldInit: ({ $advTopDataNode, $advInReadVideoDataNode, $advInArticleDataNode }) =>
    (isArticlePage() && ($advTopDataNode || $advInReadVideoDataNode)) ||
    (isNewsYouCanUsePage() && ($advTopDataNode || $advInArticleDataNode)),
};

export const advSkinModule = {
  name: 'Adv Skin',
  shouldInit: () => {
    const isVideoArticleOnMobile = isMobile() && isVideoArticlePage();
    const isNewsYouCanUseOnMobile = isMobile() && isNewsYouCanUsePage();
    return !isVideoArticleOnMobile && !isNewsYouCanUseOnMobile;
  },
};

export const advIntroModule = {
  name: 'Adv Intro',
  shouldInit: () => isNewsYouCanUsePage(),
};
